import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  gridContainer: {
    height: '385px',
    padding: 0,
  },
}))
